import { createContext, useContext } from 'react'
import { useToast } from './use-toast'
import { IUserContext } from '@/constants'

export const UserContext = createContext<IUserContext | Record<any, any>>({})

export const useUser = () => {
  const context = useContext(UserContext)
  const { toast } = useToast()

  if (!context) {
    toast({
      title: 'User Provider Error',
      description: 'User data must be used within UserProvider'
    })
  }
  return context
}
